<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<h1 class="subtitle">THE INVISIBLE<br/> INFLUENCE</h1>
<h1 class="subtitle1">A STORY OF THE MYSTIC ORIENT WITH <br/>GREAT TRUTHS WHICH CAN NEVER DIE</h1>
<p class="center">By<br/><span class="big23">ALEXANDER CANNON</span><br/><span class="small">M.D., D.P.M., PH.D., M.A., F.R.G.S., ETC.<br/>AUTHOR OF “HYPNOTISM”<br/>SENIOR AUTHOR OF “THE PRINCIPLES AND PRACTICE OF PSYCHIATRY,”<br/>“THE PRINCIPLES AND PRACTICE OF NEUROLOGY,” ETC.</span><br/><br/></p>
<p class="center"><img alt="" src="OEBPS/images/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?5c7d0281